/** 门户用户 JWT */
export const TOKEN_KEY = "token"
/** 管理后台 JWT */
export const ADMIN_TOKEN_KEY = "adminToken"

export function normalizeJwt(raw) {
  if (raw == null) return ""
  let s = String(raw).trim()
  const lower = s.toLowerCase()
  if (lower.startsWith("bearer ")) {
    s = s.slice(7).trim()
  }
  return s
}

export function getUserJwt() {
  return normalizeJwt(localStorage.getItem(TOKEN_KEY))
}

export function getAdminJwt() {
  return normalizeJwt(localStorage.getItem(ADMIN_TOKEN_KEY))
}

/**
 * 与接口请求一致：后台接口优先 admin；CRM 等业务优先 user，可互换代用。
 */
export function resolveAuthToken(isAdminApi) {
  const userToken = getUserJwt()
  const adminToken = getAdminJwt()
  if (isAdminApi) {
    return adminToken || userToken
  }
  return userToken || adminToken
}

/** 门户侧退出：清空全部本地登录态（双 token + sessionStorage） */
export function clearAllAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem("portalMenuPermissions")
  try {
    sessionStorage.clear()
  } catch (e) {
    /* ignore */
  }
}

/** 仅退出管理后台：保留门户 token */
export function clearAdminAuth() {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  try {
    sessionStorage.clear()
  } catch (e) {
    /* ignore */
  }
}
